import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _single, _TransportGuidePaymentForm } from "../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { useEffect } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { UBLPaymentMeansCodeNewEditor } from "../../UBLPaymentMeansCode/UBLPaymentMeansCodeNewEditor";

type transportGuide = {
    IDTransportGuide: number;
    TransportGuideDate: any;
    [key: string]: any;
}

interface Props {
    TransportGuide: transportGuide
}

export const TransportGuidePaymentForm = ({ TransportGuide }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_TransportGuidePaymentForm);
    // const paginador = usePaginator();

    const modalAdd = useModal("Agregar Metodo de Pago", MODAL_md);
    const modalEdit = useModal("Editar Medoto de Pago", MODAL_md);
    const modalC = useModal("Eliminar metodo de Pago", MODAL_SM);

    useEffect(() => {
        if (TransportGuide.IDTransportGuide && TransportGuide.TransportGuideDate) {
            getLista();
        }
    }, [TransportGuide.IDTransportGuide, TransportGuide.TransportGuideDate])

    const getLista = () => {
        instance.getTransportGuidePaymentFormCatalog(TransportGuide.IDTransportGuide, TransportGuide.TransportGuideDate).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTransportGuidePaymentForm', visible: true },
        { title: 'Forma de Pago', property: 'PaymentMeansTypeName', visible: true },
        { title: 'Medio de Pago', property: 'PaymentMeansDescription', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
    ];

    const create = () => {
        setBean({});
        modalAdd.open()
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        console.log(bean);
        instance.deleteTransportGuidePaymentForm(bean.TransportGuideDate, bean.IDTransportGuidePaymentForm).then(
            (resp) => {
                modalC.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    };

    const editaItem = (obj: any) => {
        instance.updateTransportGuidePaymentForm(obj).then(
            (resp: any) => {
                getLista();
                modalEdit.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const addItem = () => {
        instance.addTransportGuidePaymentForm(TransportGuide.IDTransportGuide, TransportGuide.TransportGuideDate, bean.IDUBLPaymentMeansCode, bean.Value).then(
            (resp) => {
                modalAdd.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={() => { addItem() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <UBLPaymentMeansCodeNewEditor label="Medio de Pago" idSelector={bean.IDUBLPaymentMeansCode} onChange={(e) => { setBean({ ...bean, IDUBLPaymentMeansCode: e }) }} type={null} />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, Value: e }) }} _label="Valor" />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.GroupName}</strong>
                </ModalConfirm>

            </div>
        </div>
    )
}